// ** Icons Import
import { Heart } from "react-feather"

const Footer = () => {
}

export default Footer
